import React from "react";
import { useState, useEffect } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import { enquiryHeaders } from "../components/HeaderAttribute";
import Image1 from "../image/Image1.jpeg";
import { mainTable } from "../css/Common";

const Enquirypopup = ({ data, data1, data2 }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (data2?.length > 0) {
      setTableData(data2);
    } else {
      setTableData([
        {
          RoomTypeId: "",
          AvailableRooms: "",
          Numberofrooms: "",
          numberofadults: "",
          numberofchildren: "",
          Tariff: "",
          specialtariff: "",
          amount: "",
          Size: "",
          MaxOccupancy: "",
          Bedrooms: "",
          RoomType: "",
          Balcony: "",
          LivingRoom: "",
        },
      ]);
    }
  }, [data2]);

  //  if (roomDetailsData.length === 0) {
  // setTableData([
  //   {
  //     RoomTypeId: "",
  //     AvailableRooms: "",
  //     Numberofrooms: "",
  //     numberofadults: "",
  //     numberofchildren: "",
  //     Tariff: "",
  //     specialtariff: "",
  //     amount: "",
  //     Size:"",
  // MaxOccupancy:"",
  // Bedrooms:"",
  // RoomType:"",
  // Balcony:"",
  // LivingRoom:""
  //   },
  // ]);

  const [childId, setChildId] = useState([]);

  if (!data) return null;

  //    const TesttxnEnquiryId = data2.bindEnquiryData[rowIndex].TxnEnquiryId;
  // setChildId(TesttxnEnquiryId); // still sets state for other uses

  // // Use the value directly instead of waiting for state update
  // const roomDetailsData = Object.values(data3.bindenquiryChildData).filter((item) => {
  //   return item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId);
  // });

  // if (roomDetailsData.length === 0) {
  //   setTableData([
  //     {
  //       RoomTypeId: "",
  //       AvailableRooms: "",
  //       Numberofrooms: "",
  //       numberofadults: "",
  //       numberofchildren: "",
  //       Tariff: "",
  //       specialtariff: "",
  //       amount: "",
  //       Size:"",
  //   MaxOccupancy:"",
  //   Bedrooms:"",
  //   RoomType:"",
  //   Balcony:"",
  //   LivingRoom:""
  //     },
  //   ]);
  // } else {
  //   appendToTableData(JSON.stringify(roomDetailsData));
  // }

  //   };

  //   const appendToTableData = (newDataString) => {
  //
  //     const newDataArray = JSON.parse(newDataString);
  //     handleDeleteRow(0);
  //     setTableData([]);
  //     const formattedDataArray = newDataArray.map((data) => {

  //       return {
  //          RoomTypeId: data.MstRoomTypeId,
  //   AvailableRooms: data.NoOfAvailableRooms,
  //   Numberofrooms: data.NoOfRequiredRooms,
  //   numberofadults: data.NoOfAdults,
  //   numberofchildren: data.NoOfChildren,
  //   Tariff: data.BasicTariff,
  //   specialtariff: data.SpecialTariff,
  //   amount: data.Amount,

  //   Size:data.Size,
  //   MaxOccupancy:data.MaxOccupancy,
  //   Bedrooms:data.Bedrooms,
  //   RoomType:data.RoomType,
  //   Balcony:data.Balcony,
  //   LivingRoom:data.LivingRoom

  //       };
  //     });

  //     setTableData((prevData) => [...prevData, ...formattedDataArray]);

  // const convertDate = (dateStr) => {
  //   const [mm, dd, yyyy] = dateStr.split('/');
  //   return `${mm}-${dd}-${yyyy}`;
  // };

  // const newFrom = data.BookingFrom.split("T")[0]
  // const newTo =  data.BookingTo.split("T")[0]

  return (
    <>
      <div className="mx-auto p-8 maxw-7xl">
        <div className="grid grid-cols-3 gap-6 ">
          <InputText
            inputType="text"
            title="Enquiry ID"
            name="enquiryid"
            content={data?.EnquiryNo || ""}
            placeholder=""
            disabled={true}
            // tabIndex="11"
            isRequired={true}
          />

          <InputText
            inputType="date"
            title="Enquiry date"
            name="enquirydate"
            content={data?.EnquiryDate ? data.EnquiryDate.split("T")[0] : ""}
            placeholder="Enter Date"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />
          <DropDown
            name="enquirytype"
            title="Enquiry Type"
            // type={"select-one"}
            options={Array.isArray(data1?.[0]) ? data1[0] : []}
            selectedOption={
              data?.MstEnquiryTypeId != 0 ? data?.MstEnquiryTypeId : ""
            }
            disabled={true}
            placeholder="Select Enquiry Type"
            // tabIndex="12"
             classStar="text-red-500"
            isRequired={true}
          />

          <InputText
            inputType="date"
            title="Booking From"
            name="fromdate"
            content={data?.BookingFrom ? data.BookingFrom.split("T")[0] : ""}
            placeholder="Enter Date"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
          />
          <InputText
            inputType="date"
            title="Booking To"
            name="todate"
            content={data?.BookingTo ? data.BookingTo.split("T")[0] : ""}
            placeholder="Enter Date"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Number of Days"
            name="noofdays"
            content={data?.NoOfDays || ""}
            placeholder="Enter your mobile number"
            disabled={true}
            // tabIndex="3"
            isRequired={true}
          />

          <InputText
            inputType="text"
            title="First Name"
            name="fname"
            content={data?.FirstName || ""}
            placeholder="Enter your first name"
            disabled={true}
            // tabIndex="1"
            isRequired={true}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Last Name"
            name="lname"
            content={data?.LastName || ""}
            placeholder="Enter your last name"
            disabled={true}
            // tabIndex="2"
            isRequired={true}
          />

          <InputText
            inputType="text"
            title="Mobile Number"
            name="number"
            content={data?.MobileNumber || ""}
            placeholder="Enter your mobile number"
            disabled={true}
            // tabIndex="3"
            isRequired={true}
            classStar="text-red-500"
          />

          <div className=" text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 ">
            <DropDown
              name="country"
              title="Country"
              placeholder="Select country"
              // tabIndex="5"
              isRequired={true}
              disabled={true}
              options={Array.isArray(data1?.[1]) ? data1[1] : []}
              content={data.MstCountryId}
            />
          </div>

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 ">
            <DropDown
              name="state"
              title="State"
              placeholder="Select state"
              options={Array.isArray(data1?.[2]) ? data1[2] : []}
              // tabIndex="6"
              isRequired={true}
              disabled={true}
              content={data.MstStateId}
            />
          </div>

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="city"
              title="City"
              type={"select-one"}
              options={Array.isArray(data1?.[3]) ? data1[3] : []}
              selectedOption={data.MstCityId}
              disabled={true}
              placeholder="Select Source type"
              // tabIndex="12"
            />
          </div>

          <InputText
            inputType="text"
            title="Door No & Street name"
            name="doorstreet"
            placeholder="Enter city"
            disabled={true}
            // tabIndex="8"
            isRequired={true}
            content={data.StreetDoorNo}
          />

          <InputText
            inputType="text"
            title="Area"
            name="area"
            placeholder="Enter Area"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            content={data.Area}
          />

          <InputText
            inputType="text"
            title="Pincode"
            name="pincode"
            placeholder="Enter pincode"
            disabled={true}
            // tabIndex="11"
            isRequired={true}
            content={data.Pincode}
          />

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="sourcetype"
              title="Source Type"
              type={"select-one"}
              options={Array.isArray(data1?.[4]) ? data1[4] : []}
              selectedOption={
                data.ReferralSource != 0 ? data.ReferralSource : ""
              }
              placeholder="Select No of Referral Source"
              // tabIndex="12"
               classStar="text-red-500"
              disabled={true}
            />
          </div>

          <InputText
            inputType="text"
            title="Source"
            name="source"
            content={data.Source}
            placeholder="Enter Name"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />

          <InputText
            inputType="text"
            title="Contact Number"
            name="referralcontact"
            content={data.ContactNumber}
            placeholder="Enter Number"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />
          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="idproof"
              title="ID-Proof"
              type={"select-one"}
              options={Array.isArray(data1?.[5]) ? data1[5] : []}
              selectedOption={data.idproof != 0 ? data.idproof : ""}
              placeholder="Select ID Type"
              // tabIndex="12"
              disabled={true}
            />
          </div>

          <InputText
            inputType="text"
            title="ID-Number"
            name="idvalue"
            content={data.IdNumber}
            placeholder="Enter ID-Number"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />

<InputText
            inputType="text"
            title="E-mail"
            name="email"
            content={data.Email}
            placeholder="Enter ID-Number"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />
        </div>
        <div></div>
        <div className=" mx-auto grid-cols-3 p-8 maxw-7xl"></div>
        <table className="min-w-full table-auto border border-gray-300 ">
          <thead className="bg-[#3D6643] text-white text-left">
            <tr>
              <th className="border px-2 py-2 w-[30px]">SN</th>
              <th className="border px-4 py-2 w-[270px]">Room Type</th>
              <th className="border px-4 py-2 w-[30px]">Available Rooms</th>
              <th className="border px-4 py-2 w-[160px]">Basic Tariff</th>
              <th className="border px-4 py-2 w-[160px]">Spl. Tariff</th>
              <th className="border px-4 py-2 w-[100px]">No. Of rooms</th>
              <th className="border px-2 py-2 w-[80px]">No. Of Adults</th>
              <th className="border px-2 py-2 w-[80px]">No. Of Children</th>
              <th className="border px-2 py-2 w-[150px]">Amount</th>
              {/* <th className="border px-4 py-2 w-[80px]">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {tableData.map((room, index) => (
              <tr key={index}>
                <td className="border px-2 py-2">{index + 1}</td>

                <td className="border px-4 py-2">
                  <DropDown
                    name="Rooms Type"
                    options={[{ value: room.RoomTypeId, label: room.RoomType }]}
                    selectedOption={room.RoomTypeId}
                    disabled={true}
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="availablerooms"
                    disabled={true}
                    content={room.AvailableRooms}
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="Tariff"
                    content={room.Tariff}
                    disabled={true}
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="specialtariff"
                    content={room.specialtariff}
                    disabled={true}
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="numberofrooms"
                    content={room.Numberofrooms}
                    disabled={true}
                  />
                </td>
                <td className="border px-2 py-2">
                  <InputText
                    name="numberofadults"
                    content={room.numberofadults}
                    disabled={true}
                  />
                </td>
                <td className="border px-2 py-2">
                  <InputText
                    name="numberofchildren"
                    content={room.numberofchildren}
                    disabled={true}
                  />
                </td>
                <td className="border px-2 py-4">
                  <InputText
                    name="amount"
                    content={tableData[index].amount}
                    disabled={true}
                  />
                </td>
                {/* <td className="border px-4 py-2">
                  <div className="flex gap-4 items-center justify-center">
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="w-6 h-6 text-black cursor-pointer"
                    >
                      <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                    </svg>
                    {index === tableData.length - 1 && tableData.length && (
                      <svg
                        viewBox="0 0 1024 1024"
                        fill="currentColor"
                        className="w-6 h-6 text-black cursor-pointer"
                      >
                        <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                      </svg>
                    )}
                  </div>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="mx-auto p-4 max-w-7xl">
          <ul className="space-y-4">
            {tableData
              ?.filter((room) => room.RoomTypeId) // only rows where a room type is selected
              .map((room, index) => (
                <li
                  key={index}
                  className="border border-green-500 rounded-md p-4 shadow-sm bg-white"
                >
                  <div className="flex flex-col  items-start  justify-between ">
                    {/* Checkbox & Button */}
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">
                      {room.RoomName}
                    </h2>
                    <div className="flex flex-col md:flex-row items-start md:gap-x-10">
                      {/* <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      ref={checkboxRef}
                      className="accent-green-600"
                    />
                    <button
                      onClick={handleClick}
                      className="text-green-700 hover:underline text-sm"
                    >
                      Select Room
                    </button>
                  </div> */}

                      {/* Villa Image */}
                      <img
                        src={room.Photo}
                        alt="Room"
                        className="h-36 w-36 object-cover rounded-md border"
                      />
                      <div>
                        {/* Villa Info */}
                        <div className="flex-1 flex-col w-full">
                          <div className="flex flex-col md:flex-row md:gap-x-24 flex-1">
                            {/* Left Column */}
                            <div className="flex-2 space-y-1">
                              <p className="text-sm text-gray-600">
                                Property Size:{room.Size}
                              </p>
                              <p className="text-sm text-gray-600">
                                Maximum Occupancy: {room.MaxOccupancy}
                              </p>
                              <p className="text-sm text-gray-600">
                                Villa Type:{room.RoomType}
                              </p>
                            </div>

                            {/* Center Column */}
                            <div className="flex-2 space-y-1">
                              {room.SpaceDetails ? (
                                <ul className="text-sm text-gray-600">
                                  {room.SpaceDetails.split(",").map(
                                    (item, idx) => (
                                      <li key={idx}>
                                        {idx + 1}. {item.trim()}
                                      </li>
                                    )
                                  )}
                                </ul>
                              ) : (
                                <p className="text-sm text-gray-600">
                                  Space Details: Not Available
                                </p>
                              )}
                            </div>

                            {/* Right Column */}
                            <div className="flex-2 space-y-1">
                              {room.AmenitiesDetails ? (
                                <ul className="text-sm text-gray-600 ">
                                  {room.AmenitiesDetails.split(",").map(
                                    (item, idx) => (
                                      <li key={idx}>
                                        {idx + 1}. {item.trim()}
                                      </li>
                                    )
                                  )}
                                </ul>
                              ) : (
                                <p className="text-sm text-gray-600">
                                  Amenities Details: Not Available
                                </p>
                              )}
                            </div>
                          </div>

                          {/* <div className="">
                    <p className="text-sm font-semibold text-gray-700 mb-2">
                      Rooms:{room.AvailableRooms}
                    </p>
                    <div className="grid grid-cols-12 gap-2">*/}
                          {/* Example seat data: A1 to B4 */}
                          {/*         {[
                        { id: "A1", booked: false },
                        { id: "A2", booked: true },
                        { id: "A3", booked: false },
                        { id: "A4", booked: false },
                        { id: "B1", booked: false },
                        { id: "B2", booked: true },
                        { id: "B3", booked: false },
                        { id: "B4", booked: false },
                      ].map((seat) => (
                        <button
                          key={seat.id}
                          disabled={seat.booked}
                          className={`px-3 py-2 text-sm font-medium rounded-md text-white
          ${
            seat.booked
              ? "bg-red-500 cursor-not-allowed"
              : "bg-green-500 hover:bg-green-600"
          }
        `}
                        >
                          {seat.id}
                        </button>
                      ))}
                    </div>
                  </div>  */}
                         <div className="">
                                  <p className="text-sm font-semibold text-gray-700 mb-2">
                                    Rooms: {room.AvailableRooms}
                                  </p>

                         
                                  <div className="grid grid-cols-6 gap-2">
                                  {(room.AvailableRoomsName || "")
      .split(",")
      .map((roomName, index) => (
        <button
          key={index}
          className="px-3 py-2 text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600"
        >
          {roomName.trim()}
        </button>
      ))}
                                    {/* {(room.AvailableRoomsId || "")
                                      .split(",")
                                      .map((seat, index) => {
                                        const roomId = Number(seat.trim());
                                        return (
                                          <button
                                            key={index}
                                            className="px-3 py-2 text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600"
                                          >
                                            {roomId}
                                          </button>
                                        );
                                      })} */}
                                  </div>
                                </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </div>

        <div className={mainTable.grid3}>
          <InputText
            inputType="text"
            title="Total Amount"
            name="amountpaid"
            content={data?.TotalAmount || 0}
            //content={"32000"}
            placeholder="Enter Book Amount"
            disabled={true}
            isRequired={true}
            // tabIndex="11"
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title=" Received Amount "
            name="amountpaid"
            content={"0"}
            // content={formData.amountpaid}
            placeholder="Enter Amount paid"
            disabled={true}
            isRequired={true}
            // tabIndex="11"
          />

          <InputText
            inputType="text"
            title="Balance Amount"
            name="amountremain"
            content={"0"}
            //content={formData.amountremain}
            placeholder=""
            disabled={true}
            isRequired={true}
            // tabIndex="11"
          />
        </div>
      </div>
    </>
  );
};

export default Enquirypopup;

{
  /* <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="villaname"
              title="Villa Name"
              disabled={true}
              options={Array.isArray(data1?.[3]) ? data1[3] : []}
              placeholder="Select Villa Name"
              // tabIndex="12"
              isRequired={true}
              content={data.VillaNameId}


            />
          </div> */
}

{
  /* <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="villatype"
              title="Villa Type"
              options={Array.isArray(data1?.[4]) ? data1[4] : []}
              disabled={true}
              placeholder="Select Villa Type"
              // tabIndex="12"
              content={data.VillaTypeId}


            />
          </div> */
}

{
  /* <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="adults"
              title="Adults"
              placeholder="Select No of Adults"
              // tabIndex="12"
              disabled={true}
              options={Array.isArray(data1?.[6]) ? data1[6] : []}
              content={data.adultsValue}


            />
          </div>

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="children"
              title="Children"
              placeholder="Select No of Children"
              // tabIndex="12"
              isRequired={true}
              disabled={true}
              options={Array.isArray(data1?.[7]) ? data1[7] : []}
              content={data.childrenValue}
            />
          </div>
          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="idproof"
              title="ID-Proof"
              disabled={true}
              options={Array.isArray(data1?.[5]) ? data1[5] : []}
              placeholder="Select ID Type"
              // tabIndex="12"
              content={data.IdTypeId}


            />
          </div> */
}
